export const GET_JURISDICTION_REQUEST = 'GET_JURISDICTION_REQUEST';
export const GET_JURISDICTION_SUCCESS = 'GET_JURISDICTION_SUCCESS';
export const GET_JURISDICTION_FAILED = 'GET_JURISDICTION_FAILED';

export const UPDATE_JURISDICTION_REQUEST = 'UPDATE_JURISDICTION_REQUEST';
export const UPDATE_JURISDICTION_SUCCESS = 'UPDATE_JURISDICTION_SUCCESS';
export const UPDATE_JURISDICTION_FAILED = 'UPDATE_JURISDICTION_FAILED';
